import React, { useState } from "react";
import Loading from "../../../../../../components/Loading/Loading";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import { formatExtrapayDateTime } from "../formatExtrapay";
import ExtrapayTable from "./ExtrapayTable";
import PurchasePointsDialog from "./PurchasePointsDialog";

const PointsStatementTable = ({ purchases, isLoading }) => {
  const [selected, setSelected] = useState(null);

  if (isLoading) {
    return (
      <div className="flex justify-content-center py-4">
        <Loading classNameIcon="text-4xl" />
      </div>
    );
  }

  const columns = [
    {
      key: "origin",
      header: localeText("extrapayFlowOrigin"),
      render: (row) => localeText("extrapayFlowPurchaseOrigin", { id: row.id }),
    },
    {
      key: "date",
      header: localeText("extrapayFlowDate"),
      render: (row) => formatExtrapayDateTime(row.date),
    },
    {
      key: "cycle",
      header: localeText("extrapayFlowCycle"),
      render: (row) => row.extrapayCycle,
    },
    {
      key: "points",
      header: localeText("extrapayFlowPoints"),
      render: (row) =>
        localeText("extrapayFlowSignedPoints", { amount: formatPrice(row.extrapayPoints) }),
    },
    {
      key: "details",
      header: "",
      render: (row) => (
        <button
          type="button"
          className="p-0 border-none bg-transparent cursor-pointer"
          style={{ color: "#335CFF" }}
          onClick={() => setSelected(row)}
        >
          {localeText("extrapayFlowViewDetails")}
        </button>
      ),
    },
  ];

  return (
    <>
      <ExtrapayTable
        columns={columns}
        rows={purchases}
        emptyMessage={localeText("extrapayFlowPointsEmpty")}
        rowKey={(row) => row.id}
      />
      <PurchasePointsDialog purchase={selected} onHide={() => setSelected(null)} />
    </>
  );
};

export default PointsStatementTable;
